import { formatDate } from '@angular/common';

export class Utils {
  public static isValidDate(date: any): boolean {
    return date instanceof Date && !isNaN(date.getTime());
  }

  public static isDateInTheFuture(date: Date) {
    const now = new Date();
    now.setHours(0, 0, 0, 0);
    date.setHours(0, 0, 0, 0);
    return date > now;
  }

  public static getObjectsKeys(object: any): string[] {
    return Object.keys(object);
  }

  public static isBrowserSupportsDateInput(): boolean {
    const input = document.createElement('input');
    const value = 'a';
    input.setAttribute('type', 'date');
    input.setAttribute('value', value);
    return input.value !== value;
  }

  public static formatDateMonth(date: Date, locale: string): string {
    return formatDate(date, 'MMMM y', locale);
  }

  public static randomString(length: number): string {
    return Math.random().toString(36).substr(2, length);
  }

  public static getDatesDiffInDays(date1: Date, date2: Date): number {
    const diffMs = Math.abs(date2.getTime() - date1.getTime());
    return Math.floor(diffMs / 1000 / 3600 / 24);
  }
}
